import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {ORGANISER_DASHBOARD} from "src/app/app-routing.module";
import {RaceService} from "@services";
import {FetchRaceByIdRequest, Race} from "@model";

export const RaceItemDetailsResolver: ResolveFn<Observable<Race | null> |
  Promise<Race> | Race> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   raceService: RaceService = inject(RaceService),
   router: Router = inject(Router)): Observable<Race | null> |
    Promise<Race> | Race => {
    let raceId = route.queryParams["raceId"];
    let eventId = route.queryParams["eventId"];
    if (raceId) {
      return raceService.findRaceByIdProtected(
        new FetchRaceByIdRequest(raceId), true)
        .pipe(
          take(1),
          mergeMap((res: Race | null) => {
            if (res) {
              if (eventId && res.eventId && +eventId !== res.eventId) {
                router.navigate([ORGANISER_DASHBOARD]);
                return EMPTY;
              }
              return of(res);
            } else {
              router.navigate([ORGANISER_DASHBOARD]);
              return EMPTY;
            }
          })
        );
    } else {
      router.navigate([ORGANISER_DASHBOARD]);
      return EMPTY;
    }
  }
